export type LegalDocumentSlug = "cgus" | "legal" | "privacy" | "about";

export const LEGAL_DOCUMENT_SLUGS = [
  "cgus",
  "legal",
  "privacy",
  "about",
] as const satisfies readonly LegalDocumentSlug[];

export interface LegalDocument {
  id: string;
  slug: LegalDocumentSlug;
  title: string;
  content_md: string;
  version: string;
  locale: string;
  is_published: boolean;
  effective_at: string;
  created_at: string;
  updated_at: string;
}

export interface UpsertLegalDocumentInput {
  document_id?: string;
  slug: LegalDocumentSlug;
  title: string;
  content_md: string;
  version?: string;
  locale?: string;
  is_published?: boolean;
  effective_at?: string;
}
